import { I18n } from '@calendly/i18n'

import { SearchInput } from './search_input'

export const HostsSearch = ({ selectedIds, setSelectedIds }) => (
  <SearchInput
    title={I18n.t('publisher.event_types.filters.titles.hosts')}
    selectedIds={selectedIds}
    setSelectedIds={setSelectedIds}
  />
)
